import { Box } from '@mui/material'
import { useCountdown } from '../../../sharedComponents/src/hooks/useCountdown'
import { useStoreActions, useStoreState } from '../../../store/hooks'
import { GuestBlocker } from '../components/missions/GuestBlocker'
import { LoadError, Loader } from '../components/missions/Loader'
import { MissionCard } from '../components/missions/MissionCard'
import { WeeklyCountdown } from '../components/missions/WeeklyCountdown'

export const MissionsTab = () => {
    const missions = useStoreState((state) => state.missionsService.missions)
    const nextResetAt = useStoreState((state) => state.missionsService.nextResetAt)
    const { getMissions } = useStoreActions((state) => state.missionsService)
    const isLoading = missions === undefined
    const guestEnabled = useStoreState((state) => state.missionsService.guestEnabled)
    const summaryError = useStoreState((state) => state.missionsService.summaryError)

    useCountdown(nextResetAt, () => {
        nextResetAt && setTimeout(() => getMissions(), 1000)
    })

    if (isLoading) return summaryError ? <LoadError onRetry={() => getMissions()} /> : <Loader />

    return (
        <Box
            display="flex"
            flexDirection="column"
            gap={1.5}
            width="100%"
            position="relative"
            sx={{
                borderRadius: '0',
                overflowY: 'auto',
                overflowX: 'hidden',
                padding: '0 !important',
                backgroundColor: 'transparent',
            }}
        >
            {!guestEnabled && <GuestBlocker variant="missions" />}
            {missions && missions.length > 0 ? (
                missions.map((mission) => <MissionCard key={`${mission.id}-${mission.resetDate}`} {...mission} />)
            ) : (
                <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                    <WeeklyCountdown />
                </Box>
            )}
        </Box>
    )
}
